<template>
  <div class="agent-upload-page">
    <div class="agent-upload-inner">
      <header class="page-header">
        <h1>Certificate submitted</h1>
        <p class="purpose-lead">{{ statusMessage }} The requesting team has been notified.</p>
      </header>

      <section class="purpose-panel" :class="{ 'purpose-panel--alert': failedCount > 0 }">
        <div class="purpose-icon" aria-hidden="true">
          <i :class="statusIcon"></i>
        </div>
        <div class="purpose-body">
          <h2>{{ statusTitle }}</h2>
          <p v-if="passedCount + failedCount > 0">
            {{ passedCount }} passed
            <template v-if="failedCount > 0"> · {{ failedCount }} still need attention</template>
          </p>
          <p v-if="failedCount > 0" class="next-action">
            <span class="next-label">Next:</span>
            Watch for a follow-up if an updated certificate or endorsement is still required.
          </p>
        </div>
      </section>

      <section class="purpose-panel">
        <div class="purpose-icon" aria-hidden="true">
          <i class="fas fa-envelope-open-text"></i>
        </div>
        <div class="purpose-body">
          <h2>What happens next</h2>
          <p>The requesting team will review this submission. You’ll hear by email if anything else is needed.</p>
        </div>
      </section>

      <section class="purpose-panel purpose-panel--tools">
        <div class="purpose-icon" aria-hidden="true">
          <i class="fas fa-building"></i>
        </div>
        <div class="purpose-body">
          <h2>About this review</h2>
          <p>
            Questions about the request itself should go to the team that sent you the upload link.
            To learn more about the review platform,
            <a href="mailto:sales@get-adi.com">email sales@get-adi.com</a>.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecureUploadComplete',
  data() {
    return {
      token: null,
      passedCount: 0,
      failedCount: 0
    };
  },
  
  computed: {
    statusIcon() {
      if (this.failedCount === 0) return 'fas fa-check-circle';
      return 'fas fa-exclamation-triangle';
    },
    
    statusTitle() {
      if (this.failedCount === 0) return 'Requirements met on this certificate';
      return 'Some items still need attention';
    },
    
    statusMessage() {
      if (this.failedCount === 0) {
        return 'This certificate met the items we could check.';
      }
      return `${this.failedCount} item${this.failedCount === 1 ? '' : 's'} still need attention.`;
    }
  },
  
  created() {
    this.token = this.$route.params.token;
    this.passedCount = parseInt(this.$route.query.passed) || 0;
    this.failedCount = parseInt(this.$route.query.failed) || 0;
  }
};
</script>

<style scoped>
.agent-upload-page {
  min-height: 100vh;
  background: #f8fafc;
  color: #0f172a;
}

.agent-upload-inner {
  max-width: 40rem;
  margin: 0 auto;
  padding: 2rem 1.25rem 3rem;
}

.page-header {
  margin-bottom: 1.25rem;
}

.page-header h1 {
  margin: 0 0 0.45rem;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
}

.purpose-lead {
  margin: 0;
  font-size: 0.98rem;
  color: #334155;
  line-height: 1.5;
}

.purpose-panel {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.85rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 1rem 1.1rem;
  margin-bottom: 0.85rem;
}

.purpose-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.55rem;
  background: #f1f5f9;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.purpose-panel--alert .purpose-icon {
  background: #fff7ed;
  color: #c2410c;
}

.purpose-body h2 {
  margin: 0 0 0.35rem;
  font-size: 1.05rem;
  font-weight: 700;
}

.purpose-body p {
  margin: 0 0 0.4rem;
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.45;
}

.purpose-body p:last-child {
  margin-bottom: 0;
}

.next-label {
  font-weight: 700;
  color: #0f172a;
}

.purpose-body a {
  color: var(--p-accent, #1e3a5f);
  font-weight: 600;
}
</style>
